import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from, until } from '@helpers/media';
import { buttonTheme } from '@stories/Components/Buttons/ButtonShared.styles';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) `
  ${setCssVar('bgColor', brand.hta.greenDark)};
  ${setCssVar('fgColor', brand.white)};

  background: ${cssVar('bgColor')};
  color: ${cssVar('fgColor')};
  text-align: center;

  .theme-apl & {
    ${setCssVar('bgColor', brand.black)};
    ${setCssVar('fgColor', brand.white)};
  }

  .theme-hh & {
    ${setCssVar('bgColor', brand.hortHouse.greenDark)};
    ${setCssVar('fgColor', brand.white)};
  }
`;
const Inner = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const Title = styled.h2 `
  ${HeadingStyles.H4Styles};
  margin: 0 0 16px;

  @media ${until(Device.Tablet)} {
    font-size: 20px;
  }
`;
const Content = styled.div `
  ${RichTextStyles.contentStyles};
  margin: 0 0 48px;

  p {
    @media ${until(Device.Tablet)} {
      font-size: 18px;
    }
  }
`;
const Cta1 = styled(LinkButton) `
  margin: 0;

  .theme-hta & {
    ${buttonTheme({
    bgColor: brand.hta.green,
    borderColor: brand.hta.green,
    fgColor: brand.black,
})}

    &:focus,
      &:hover {
      ${buttonTheme({
    bgColor: brand.hta.greenLight,
    borderColor: brand.hta.greenLight,
    fgColor: brand.black,
})}
    }

    &:active {
      ${buttonTheme({
    bgColor: brand.hta.green,
    borderColor: brand.hta.green,
    fgColor: brand.black,
})}
    }
  }
`;
const Cta2 = styled.a `
  display: block;
  color: currentColor;
  ${ParagraphStyles.SmallStyles};
  margin: 32px 0 0;
  text-decoration: none;

  @media ${until(Device.Tablet)} {
    font-size: 18px;
  }

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const SummaryArea = styled(SectionWrapper) ``;
const SummaryGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;
const SummaryColumn = styled.div `
  grid-column: 1 / span 12;

  @media ${from(Device.Tablet)} {
    grid-column: 3 / span 8;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 4 / span 6;
  }

  ${Content} {
    margin-bottom: 0;
  }
`;
export default {
    Container,
    Content,
    Cta1,
    Cta2,
    Inner,
    SummaryArea,
    SummaryColumn,
    SummaryGrid,
    Title,
};
